/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const product = {
  productDetails: {
    id: 'Código',
    quantity: 'Cantidad',
    productDetails: 'Detalles del producto',
    specification: 'Especificaciones',
    reviews: 'Comentarios',
    shipping: 'Naviero',
    share: 'Compartir',
    showComments: 'Mostrar reseñas',
    noComments: 'No hay valoraciones aún',
    productPrice: 'Precio del producto',
    noProductImage: 'No hay imagen disponible, {{ product }}',
  },
  productList: {
    filterBy: {
      label: 'Filtrar por',
      action: 'Filtrar por',
    },
    activeFilter:
      '{{filter}}, al hacer clic en este botón se eliminará el filtro',
    appliedFilter: 'Filtro aplicado:',
    showLess: 'Mostrar menos...',
    showMore: 'Mostrar más...',
    sortBy: 'Ordenar por',
    sortResults: 'Ordenar resultados',
    backToTopBtn: 'VOLVER AL PRINCIPIO',
    showMoreBtn: 'MOSTRAR MÁS',
    productSearchPagination: 'Paginación de búsqueda de productos',
    productListResults: 'Lista de resultados del producto',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filtrar por',
      action: 'Filtrar por',
      facet: 'Filtrar resultados por facetas',
      name: 'Filtrar por {{name}}',
    },
    appliedFilter: 'Filtro aplicado:',
    showLess: 'Mostrar menos...',
    showMore: 'Mostrar más...',
    sortBy: 'Ordenar por',
    ariaLabelShowLess:
      'Mostrar menos, al hacer clic en este botón se reducirán las opciones para el grupo activo',
    ariaLabelShowMore:
      'Mostrar más... utton, al hacer clic en este botón se mostrarán todas las opciones para el grupo activo',
    ariaLabelItemsAvailable: '{{name}}, {{state}} {{count}} Artículo disponible',
    ariaLabelItemsAvailable_other:
      '{{name}}, {{state}} {{count}} Artículos disponibles',
    decreaseOptionsVisibility:
      'Las opciones se ocultaban del grupo activo, tabléalo hacia atrás para leerlas o hacia adelante para el siguiente grupo',
    increaseOptionsVisibility:
      'Se agregaron más opciones al grupo activo, tabulación hacia atrás para leerlas o hacia adelante para el siguiente grupo',
  },
  productSummary: {
    id: 'Código',
    showComentarios: 'Mostrar reseñas',
    showComentariosDetailed:
      'Mostrar {{count}} opiniones, Valorado {{rating}} de 5 estrellas',
    share: 'Compartir',
    newItemPrice: 'Precio del artículo nuevo',
  },
  productReview: {
    overallClassification: 'Valoración general',
    reviewTitle: 'Título de la reseña',
    writeYourComments: 'Escribe tus comentarios',
    rating: 'Clasificación',
    ratingRequired: 'Clasificación del producto, requerida',
    addRate: 'Añadir tarifa: {{count}} estrella',
    addRate_other: 'Añadir tarifa: {{count}} estrellas',
    reviewerName: 'Nombre del revisor (opcional)',
    writeReview: 'Escribe una reseña',
    more: 'Show More Comentarios',
    less: 'Show Less Comentarios',
    thankYouForReview:
      'Thank you for the review! Note that reviews may require review before appearing here.',
    postReviewFail:
      'Algo salió mal al publicar su reseña. Por favor, inténtelo de nuevo más tarde.',
  },
  productCarousel: {
    carouselLabel: 'Carrusel, {{title}}',
  },
  addToCart: {
    itemsAddedToYourCart: 'Artículo(s) añadido(s) a tu carrito',
    itemsIncrementedInYourCart:
      'Este artículo ya estaba en su carrito. Se actualizó la cantidad.',
    items: 'Artículos',
    updatingCart: 'Actualizando el carrito...',
    addToCart: 'Añadir a la cesta',
    viewCart: 'Ver carrito',
    proceedToCheckout: 'Proceder al pago',
    checkQuantity: 'Consultar Disponibilidad',
    quantity: 'Introduzca la cantidad de PAQUETES deseados',
    quantityFull: 'Introduzca la cantidad de PAQUETES deseados',
    outOfStock: 'Agotado',
    inStock: 'En stock',
    selectStyleAndSize: 'Seleccione el estilo y el tamaño para comprobar el stock',
    removeFromCart: 'Eliminar el producto del carrito',
    closeModal: 'Cerrar modal',
    buyItAgain: 'Cómpralo de nuevo',
    addToActiveCart: 'Añadir a la cesta activa',
    unitTable: {
      quantity: 'Unidad/Embalaje',
      unitType: 'Embalaje',
      unitWeight: "Peso",
      unitSize: "Medida"
    },
  },
  TabPanelContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Detalles del Producto',
      ProductSpecsTabComponent: 'Especificaciones',
      ProductReviewsTabComponent: 'Comentarios',
      deliveryTab: 'Naviero',
      SparePartsTabComponent: ' Recambios',
      TechnicalAndSafetyTabComponent: 'Documentación Descargable'
    },
    tabPanelContainerRegion: 'Grupo de pestañas con más detalles del producto',
  },
  addToWishList: {
    add: 'Añadir a la lista de deseos',
    remove: 'Eliminar de la lista de deseos',
    anonymous: 'Inicie sesión para agregar a la lista de deseos',
    addedToWishList: 'Producto añadido a la lista de deseos',
    removedFromWishList: 'Producto eliminado de la lista de deseos',
  },
  stockNotification: {
    notifyMe: 'NOTIFICARME',
    stopNotify: 'NOTIFICACIÓN DE DETENCIÓN',
    getNotify: 'Reciba una notificación cuando este producto esté disponible.',
    getNotifySuffix: 'para recibir una notificación cuando este producto esté disponible.',
    activateChannelsPrefix: 'Para recibir una notificación, debe activar la función ',
    channelsLink: 'Canales de notificación',
    activateChannelsSuffix: '.',
    notified: 'Se le notificará cuando este producto vuelva a estar disponible.',
    getNotified: 'Reciba una notificación cuando este producto vuelva a estar disponible.',
    unsubscribeSuccess:
      'No recibirá una notificación de devolución de existencias para este producto.',
    subscriptionDialog: {
      header: 'Suscripción agotada',
      notifiedPrefix: 'Se le notificará sobre:',
      notifiedSuffix: 'tan pronto como este producto vuelva a estar disponible.',
      manageChannelsPrefix:
        'Administre sus canales de notificación preferidos en el ',
      manageChannelsLink: 'Preferencia de notificación',
      manageChannelsSuffix: ' página.',
      manageSubscriptionsPrefix: 'Puedes gestionar tus suscripciones en ',
      manageSubscriptionsLink: 'Mis Intereses',
      manageSubscriptionsSuffix: ' página.',
      okBtn: 'De acuerdo',
      subscribing:
        'Suscribirse a las notificaciones de falta de existencias para este producto',
    },
  },
  itemCounter: {
    removeOne: 'Quita uno',
    addOneMore: 'Añade uno más',
    quantity: 'sanitario',
  },
  productView: {
    gridView: 'Seleccione esta opción para cambiar a Vista de cuadrícula',
    listView: 'Seleccione esta opción para cambiar a la vista de lista',
  },
};
